<template>
  <div id="app">
    <!-- Preloader Start -->
    <HeaderComp />
    <!-- Preloader Start -->

    <!-- Slider Area Start-->
    <div class="services-area">
      <div class="container">
        <!-- Section-tittle -->
        <div class="row d-flex justify-content-center">
          <div class="col-lg-8">
            <div class="section-tittle text-center mb-80">
              <h2>Reset Password​</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Slider Area End-->
    <!-- Slider Area Start-->
    <div class v-if="sent">
      <div class="container">
        <!-- Section-tittle -->
        <div class="row d-flex justify-content-center">
          <div class="col-lg-8">
            <div class="section-tittle text-center mb-80">
              <h2 class="sent">Password has been changed​</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ================ contact section start ================= -->
    <section class="contact-section" v-if="!sent">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="contact-title">Enter new password</h2>
          </div>
          <div class="col-lg-8">
            <form
              class="form-contact contact_form"
              @submit.prevent="passReset()"
              id="resetForm"
              ref="resetForm"
              novalidate="novalidate"
            >
              <div class="row">
                <div class="col-12">
                  <div class="errors">
                    <div
                      v-for="error in errors"
                      :key="error"
                      class="text-danger"
                    >{{translate(error)}}</div>
                  </div>
                  <div class="form-group">
                    <input
                      class="form-control valid"
                      name="name"
                      id="name"
                      v-model="password"
                      type="text"
                      onfocus="this.placeholder = ''"
                      onblur="this.placeholder = 'Enter new password'"
                      placeholder="Enter new password"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group mt-3">
                <button type="submit" class="button button-contactForm boxed-btn">Reset</button>
              </div>
            </form>
          </div>
          <div class="col-lg-3 offset-lg-1">
            <div class="media contact-info">
              <span class="contact-info__icon">
                <i class="ti-email"></i>
              </span>
              <div class="media-body">
                <a href="mailto:support@nani.chat">
                  <h3>support@nani.chat</h3>
                </a>
                <p>Send us your query anytime!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ================ contact section end ================= -->
    <FooterComp />
  </div>
</template>

<script>
import HeaderComp from "./sub/Header";
import FooterComp from "./sub/Footer";

export default {
  name: "App",
  data() {
    return {
      errors: [],
      username: this.$route.params.username,
      password: "",
      token: this.$route.params.token,
      gResponse: "",
      message: "",
      subject: "",
      sent: false
    };
  },

  methods: {
    async passReset() {
      //this.sent = true;
      console.log("captcha", this.gResponse);

      let response = await this.$axios.post(config.url.resetPassword, {
        password: this.password,
        token: this.token,
        username: this.username
      });
      this.errors = response.data.errors;
      if (this.errors.length == 0) {
        //success
        this.email = response.data.email;
        this.sent = true;
      }
      console.log(response.data);
    },
    saveToken(res) {
      this.gResponse = res;
      console.log("saved token", this.gResponse);
    }
  },
  components: { HeaderComp, FooterComp }
};
</script>

<style>
.sent {
  color: #3eff3e;
}
</style>
